import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import { Link } from 'react-router-dom';
import overviewMd from './content/overview.md?raw';
import genericSamlMd from './content/generic-saml.md?raw';
import azureAdMd from './content/azure-ad.md?raw';
import oktaMd from './content/okta.md?raw';
import googleWorkspaceMd from './content/google-workspace.md?raw';
import styles from './SsoDocs.module.css';

const TABS = [
  { id: 'overview', label: 'Overview', content: overviewMd },
  { id: 'generic-saml', label: 'Generic SAML', content: genericSamlMd },
  { id: 'azure-ad', label: 'Microsoft Entra ID', content: azureAdMd },
  { id: 'okta', label: 'Okta', content: oktaMd },
  { id: 'google-workspace', label: 'Google Workspace', content: googleWorkspaceMd },
];

export default function SsoDocs() {
  const [activeTab, setActiveTab] = useState('overview');

  useEffect(() => {
    document.title = 'KNOW - SSO Admin Guide';
  }, []);

  const activeContent = TABS.find((t) => t.id === activeTab)?.content || '';

  return (
    <div className={styles.docsContainer}>
      <Link to="/docs" className={styles.backLink}>
        &larr; Back to Docs
      </Link>
      <h1 className={styles.title}>SSO Admin Guide</h1>

      <div className={styles.tabBar}>
        {TABS.map((tab) => (
          <button
            key={tab.id}
            type="button"
            className={`${styles.tab} ${activeTab === tab.id ? styles.activeTab : ''}`}
            onClick={() => setActiveTab(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <div className={styles.content}>
        <ReactMarkdown rehypePlugins={[rehypeRaw]}>{activeContent}</ReactMarkdown>
      </div>
    </div>
  );
}
